import styled from "styled-components";

export const Container = styled.div`
  background: blueviolet;
  width: 100vw;
  height: 100vh;
`;

export const MainContent = styled.main``;
